<template>
  <div>
    <BaseFormCheckbox
      v-if="$sitewideConfig.config.newsletterEnabled"
      v-model="subscribeEmail"
      name="subscribeEmail"
      :label="$sitewideConfig.config.newsletterOffersText"
    />
    <BaseFormCheckbox
      v-if="$sitewideConfig.config.newsletterSmsEnabled"
      v-model="subscribeSms"
      name="subscribeSms"
      :label="$sitewideConfig.config.newsletterSmsText"
    />
    <div v-if="subscribeSms" class="text-left">
      By opting-in to promotional SMS/texts, you agree to receive recurring or automated promotional and personalized
      text messages (e.g. cart reminders, new product announcements) from {{ $sitewideConfig.config?.siteName }}.
      Consent is not a condition of any purchase from {{ $sitewideConfig.domain }}. Message frequency varies. Message
      and data rates may apply. View <a href="/terms-and-conditions/" target="_blank">Terms and Conditions</a> and
      <a href="/privacy-policy/" target="_blank">Privacy Policy</a>.
    </div>
  </div>
</template>

<script setup lang="ts">
const { isProduction } = useUtils()
const cookie = useCookie<object>('checkoutSubscribe', {
  secure: isProduction(),
})
const subscribeEmail = ref(true)
const subscribeSms = ref(false)
watch([subscribeEmail, subscribeSms], setSubscribeCookie)
onMounted(() => setSubscribeCookie())

function setSubscribeCookie() {
  const object = {
    subscribeEmail: subscribeEmail.value,
    subscribeSms: subscribeSms.value,
  }

  cookie.value = object
}
</script>
